export enum AmostrasUtingaScopesEnum {
  ComAmostrasAmostrasLogUsuarios = 'ComAmostrasAmostrasLogUsuarios',
}

export enum AmostrasUtingaEventsEnum {
  Criadas = 'amostras-utinga-cadastro-producao',
  Criada = 'amostra-utinga-cadastro-producao',
  Alterada = 'amostra-utinga-alterada',
}
